module.exports = __webpack_public_path__ + "static/media/jisu.2bd52d30.png";